import trackAdditionalGallerySlideClose from '../track-event/additional-gallery-slide-close';
import trackAdditionalGallerySlideOpen from '../track-event/additional-gallery-slide-open';
import trackAdditionalGallerySlideView from '../track-event/additional-gallery-slide-view';
import trackAdditionalGallerySlideInaction, { EVENT_NAME as SCREENSHOT_INACTION_EVENT_NAME } from '../track-event/additional-gallery-slide-inaction';
import galleryTracker from './_gallery';



export default galleryTracker({
  SCREENSHOT_INACTION_EVENT_NAME,
  trackSlideView: trackAdditionalGallerySlideView,
  trackSlideOpen: trackAdditionalGallerySlideOpen,
  trackSlideClose: trackAdditionalGallerySlideClose,
  trackSlideInaction: trackAdditionalGallerySlideInaction
});



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/additional-gallery.js